const storeList = {
  store: ['탄방점', '둔산점', '자양점', '충대점'],
  storeAll : ['전체', '탄방점', '둔산점', '자양점', '충대점']
};

export default storeList;